import React from 'react';
import {AxiosError} from "axios";
import {Banner} from "@shopify/polaris";

import {getAxiosErrorMessage} from "../util/AxiosUtil";

type AxiosErrorBannerProps = {
    axiosError: AxiosError | null,
    onDismiss: () => void
}

const AxiosErrorBanner = ({axiosError, onDismiss} : AxiosErrorBannerProps) => {

    if (!axiosError) {
        return null;
    }
    const errorMessage = getAxiosErrorMessage(axiosError);
    return (
        <div style={{padding: '16px'}}>
            <Banner
                title="Error"
                status="critical"
                onDismiss={onDismiss}
            >
                <p>{errorMessage}</p>
            </Banner>
        </div>
    )
};

export default AxiosErrorBanner;